import { DOMProps } from '../../core/types/dom.js';
import { WithChildren } from '../../core/types/with-children.js';
import { Paragraph } from '../../typography/paragraph/Paragraph.js';
import { Text } from '../../typography/text/Text.js';
import { useInformationOverlayContext } from './hooks/useInformationOverlayContext.js';

//#region Typings
/**
 * @public
 */
export interface InformationContentProps extends DOMProps, WithChildren {}
//#endregion Typings

/**
 * The content of the InformationOverlay.
 * @public
 */
export const Content = ({ children, id: propId }: InformationContentProps) => {
  const { id } = useInformationOverlayContext();

  if (typeof children === 'string') {
    return <Paragraph id={propId ?? id}>{children}</Paragraph>;
  }
  return (
    <Text as="div" textStyle="base" id={propId ?? id}>
      {children}
    </Text>
  );
};

Content['displayName'] = 'InformationOverlay.Content';
